import { Star } from "lucide-react";

export function StarRating({ value = 0, onChange, size = 16, readOnly = false, testid }) {
  return (
    <div className="flex items-center gap-0.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          disabled={readOnly}
          onClick={() => onChange && onChange(i)}
          className={readOnly ? "cursor-default" : "cursor-pointer"}
          data-testid={testid ? `${testid}-star-${i}` : undefined}
        >
          <Star
            size={size}
            className={i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}
          />
        </button>
      ))}
    </div>
  );
}
